import gql from 'graphql-tag';

/**
 * Data of the block project-service-report-approval ("Service: Freigabe"): the approval state and
 * the top-level note `serviceApprovementNote`. Read through `Project.blocks.serviceReportApproval`,
 * which checks the block's read permission.
 */
export const PROJECT_SERVICE_REPORT_APPROVAL_FIELDS = gql`
  fragment projectServiceReportApprovalFields on ProjectServiceReportApprovalBlock {
    id
    number
    serviceApprovementVerificationState
    serviceApprovementNote
  }
`;
